export default "__VITE_ASSET__By355whd__"